import io from 'socket.io-client'
import eventTunnel from '@/utils/eventTunnel'
import { GPS_INTERVAL } from '@/app.config'

const state = {
  isConnected: false
}

const mutations = {
  SET_SOCKET_CONNECTED (state) {
    state.isConnected = true
  }
}

const actions = {
  connect ({ commit, dispatch }) {
    const socket = io(`${process.env.VUE_APP_SOCKET_SERVER}`)

    socket.on('connect', () => {
      commit('SET_SOCKET_CONNECTED')

      setInterval(() => {
        socket.emit('getBusList')
      }, GPS_INTERVAL)
    })

    socket.on('setBusList', (busList) => {
      dispatch('bus/setBusList', busList, { root: true })
    })

    socket.on('setBusListError', () => {
      // error
    })

    eventTunnel.$on('bus_getBusList', () => {
      socket.emit('getBusList')
    })
  }
}

const getters = {
  isConnected: state => state.isConnected
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
